import React from 'react';
import ResultPageModalButtons from '../../../common/components/redesignComponents/ResultPageComponents/ResultPageModalButtons';

function RcFamigliaModalButtons({
  insuranceRequest,
  processingQuote,
  type,
  riskQuotations,
  removeItemFromCart,
}) {
  const title = type.id === 'res_civile' && insuranceRequest.product.id === 1004
    ? 'Rc Famiglia'
    : type.name;

  return (
    <ResultPageModalButtons
      insuranceRequest={insuranceRequest}
      processingQuote={processingQuote}
      type={type}
      riskQuotations={riskQuotations}
      removeItemFromCart={removeItemFromCart}
      title={title}
      selectFirstLabel="Responsabilita Civile"
      excludedCompanyIds={[8]}
    />
  );
}

export default RcFamigliaModalButtons;
